export const CORRECTION_MODAL_FORM = 'correctionModalForm';
export const SUBMIT_CORRECTION_MODAL_FORM = 'submitCorrectionModalForm';
